export default {
  service_provider_daily_settlement: {
    name: '运营商日结算',
    prop: {
      settled_begin_time: '结算日',
      settled_time_range: '结算时间范围',
      ev_charging_station: '充电站',
      net_income_amount: '运营商净收入',
      settled_amount: '结算原价',
      settled_discount_amount: '优惠/商家让利金额',
      total_transaction_fee_amount: '交易手续费',
      total_tax_amount: '税费',
      total_sharing_amount: '渠道费',
      service_provider: '运营商'
    },
    titles: {
      base_info: '基本信息'
    },
    detail_tags: {
      detail: '基本信息',
      station_daily_settlements: '充电站日结算',
      settlements: '结算明细'
    }
  }
}
